export default __webpack_public_path__ + "static/media/Digital Keys.43bf8627.svg";